<template>
  <div class="cameraManage column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div>设备名称：</div>
        <div class="width200">
          <el-input placeholder="请输入设备名称" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="margin-left30">设备序列号：</div>
        <div class="width200">
          <el-input placeholder="请输入设备序列号" style="width: 100%;" clearable v-model="deviceSerial"></el-input>
        </div>
        <div class="margin-left30">设备验证码：</div>
        <div class="width200">
          <el-input placeholder="请输入设备验证码" style="width: 100%;" clearable v-model="validateCode"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left30" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="flex1"></div>
        <div class="btn-blue width140 btn-height40 margin-left20" @click="clickAdd" v-if="canOperate">
          <el-icon>
            <plus/>
          </el-icon>
          新建
        </div>
      </div>
      <div class="margin-top20">
        <el-table :data="tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="name" label="设备名称" align="center"></el-table-column>
          <el-table-column prop="deviceSerial" label="设备序列号" align="center"></el-table-column>
          <el-table-column prop="validateCode" label="设备验证码" align="center"></el-table-column>
          <el-table-column label="设备类型" align="center">
            <template #default="scope">
              {{ scope.row.type === 1 ? '配药' : scope.row.type === 2 ? '制药' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
          <el-table-column label="操作列" align="left" width="280" v-if="canOperate">
            <template #header>
              <div class="margin-left20">操作列</div>
            </template>
            <template #default="scope">
              <div class="row-me row-center">
                <div class="btn-blue width100 btn-height40 margin-left20" @click="clickEdit(scope.row)">
                  <el-icon>
                    <edit/>
                  </el-icon>
                  修改
                </div>
                <div class="btn-grey width100 btn-height40 margin-left20"
                     @click="clickDelete(scope.row)">
                  <el-icon>
                    <delete/>
                  </el-icon>
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="margin-top20">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 新建修改设备 -->
    <el-dialog :title="selectItem.id?'修改设备':'新建设备'" v-model="visibleAdd" width="40%" top="20vh"
               :destroy-on-close="true">
      <div class="padding20">
        <div class="row-me row-center">
          <div><span class="red-star">*</span>&emsp;设备名称：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入设备名称" style="width: 100%;" clearable v-model="selectItem.name"
                      :class="{'red-border':showRedBorder&&(selectItem.name===''||selectItem.name===null)}"
                      maxlength="50">
            </el-input>
          </div>
        </div>
        <div class="row-me row-center margin-top30">
          <div><span class="red-star">*</span>设备序列号：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入设备序列号" style="width: 100%;" clearable
                      v-model="selectItem.deviceSerial"
                      :class="{'red-border':showRedBorder&&(selectItem.deviceSerial===''||selectItem.deviceSerial===null)}"
                      maxlength="50">
            </el-input>
          </div>
        </div>
        <div class="row-me row-center margin-top30">
          <div><span class="red-star">*</span>设备验证码：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入设备验证码" style="width: 100%;" clearable
                      v-model="selectItem.validateCode"
                      :class="{'red-border':showRedBorder&&(selectItem.validateCode===''||selectItem.validateCode===null)}"
                      maxlength="50">
            </el-input>
          </div>
        </div>
        <div class="row-me row-center margin-top30">
          <div><span class="red-star">*</span>&emsp;设备类型：</div>
          <div class="flex1 margin-left5">
            <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                       :class="{'red-border':showRedBorder&&(selectItem.type===''||selectItem.type===null)}"
                       v-model="selectItem.type">
              <el-option v-for="item in [{id:1,name:'配药'},{id:2,name:'制药'}]" :key="item.id"
                         :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top100">
          <div class="btn-blue width140 btn-height40" @click="clickSave">保存</div>
          <div class="btn-grey width140 btn-height40 margin-left20" @click="clickCancel">取消</div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: '',
      deviceSerial: '',
      validateCode: '',
      tableData: [],
      visibleAdd: false,
      selectItem: {
        name: '',
        deviceSerial: '',
        validateCode: '',
      },
      showRedBorder: false,
      pageNo: 1,
      total: 0,
      canOperate: false,
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.pageNo = 1
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //新建
    clickAdd() {
      this.selectItem = {
        name: '',
        deviceSerial: '',
        validateCode: '',
      }
      this.showRedBorder = false
      this.visibleAdd = true
    },
    //查询
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.name = ''
      this.deviceSerial = ''
      this.validateCode = ''
      this.pageNo = 1
      this.getData()
    },
    //编辑
    clickEdit(item) {
      this.selectItem = this.$method.deepClone(item)
      this.showRedBorder = false
      this.visibleAdd = true
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除【" + item.name + "】吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/camera/delete', [item.id]).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.pageNo = 1
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //保存
    clickSave() {
      if (this.selectItem.name === '' || this.selectItem.name === null || this.selectItem.deviceSerial === '' ||
          this.selectItem.deviceSerial === null || this.selectItem.validateCode === '' || this.selectItem
              .validateCode === null || this.selectItem.type === null || this.selectItem.type === '') {
        this.showRedBorder = true
        return
      }
      this.$postRequest('/admin/camera/update', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleAdd = false
          this.pageNo = 1
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消
    clickCancel() {
      this.visibleAdd = false
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/camera/page', {
        name: this.name,
        deviceSerial: this.deviceSerial,
        validateCode: this.validateCode,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.tableData = res.data.list
          this.total = res.data.totalRow
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.cameraManage {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .dialog-content1 {
    height: 70vh;
    padding: 20px 50px 30px 150px;
    font-size: 18px;
    color: #222222;
  }
}
</style>
